














import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    flex: Boolean,
    disabled: Boolean,
    width: {
      type: [Number, String],
      default: 500
    }
  },
  setup(props) {
    const maxWidth = computed(() => {
      return isNaN(+props.width) ? props.width + "" : props.width + "px";
    });

    return {
      maxWidth
    };
  }
});
